import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'

const RequestFundModalUI = ({context, messageList, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    // request amount
    requestAmount, onRequestAmountChange, requestAmountError, setRequestAmountError,
    // dueDate
    dueDate, onDueDateChange, dueDateError, setDueDateError,
  }) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_request_fund'
    buttonMessageKey='c_request'
    cancelMessageKey='c_cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='requestAmount' required={true} maxLength={100}
      messageList={messageList} labelKey='c_request_amount'
      value={requestAmount} onChange={onRequestAmountChange}
      error={requestAmountError} setError={setRequestAmountError}
      autoFocus={true}
    />
    <InputDateUI context={context} name='dueDate'
      messageList={messageList} labelKey='c_required_by'
      selectedDateISO={dueDate} onChange={onDueDateChange}
      error={dueDateError} setError={setDueDateError}
    />
  </ModalFormUI>

export default RequestFundModalUI
